/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetemailfailed2Inputs */

const zh_auth_resetemailfailed2 = /** @type {(inputs: Auth_Resetemailfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送重置邮件失败`)
};

const en_auth_resetemailfailed2 = /** @type {(inputs: Auth_Resetemailfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send reset email`)
};

const es_auth_resetemailfailed2 = /** @type {(inputs: Auth_Resetemailfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar el correo de restablecimiento`)
};

/**
* | output |
* | --- |
* | "Failed to send reset email" |
*
* @param {Auth_Resetemailfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetemailfailed2 = /** @type {((inputs?: Auth_Resetemailfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetemailfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetemailfailed2(inputs)
	if (locale === "en") return en_auth_resetemailfailed2(inputs)
	return es_auth_resetemailfailed2(inputs)
});
export { auth_resetemailfailed2 as "auth_resetEmailFailed" }